import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';

// rxjs
import 'rxjs/add/operator/first';
import { _throw } from 'rxjs/observable/throw';
import { Observable } from 'rxjs/Observable';

// Reducers
import * as fromAuth from '../../auth/reducers';

@Injectable()
export class SessionService {

  // Constructor
  constructor(
    private store: Store<fromAuth.State>
  ) { }

  // Method to get the user
  private getUser(): any {
    let user;

    this.store.select(state => state.auth.login.user)
      .do(data => { user = data; })
      .first().subscribe();

    return user;
  }

  // Method to know if the current user can create a project
  public canCreateProject(): boolean {
    return this.getUser() && this.getUser().enabledCreateProject;
  }

  // Method to know if the current user is Administrator
  public isAdministrator(): boolean {
    return this.getUser() && this.getUser().user_role.role.toLowerCase() === 'administrator';
  }

  // Method to know id the current user is Owner
  public isOwner(): boolean {
    return this.getUser() && this.getUser().user_role.role.toLowerCase() === 'owner';
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/session.service.ts